import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
class ReminderDocument extends GenericListTab {
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        //Dummy, wird im Dialog überschrieben
        return null;
    }
}
export default ReminderDocument;